export default __webpack_public_path__ + "static/media/aute-button.54273570.png";